import { absolutePath } from "./absolutePath";

export const importContacts = {
  createUsingOneSchema: () => absolutePath("one_schema_import_contacts"),
};
